module.exports = __webpack_public_path__ + "static/media/FitFeed_Brand.d1cc15ea.png";